import { RESERVED_FIELDS } from 'app/models/reserved-fields.constant'

/**
 * Default primary key if none is specified.
 */
export const DEFAULT_PK = RESERVED_FIELDS.id

/**
 * Default parent identifier if none is specified.
 */
export const DEFAULT_PARENTS_IDENTIFIER = RESERVED_FIELDS.parentsInfo

/**
 * Default owner identifier if none is specified.
 */
export const DEFAULT_OWNER_IDENTIFIER = RESERVED_FIELDS.createdBy
